import React from 'react';
import styled from "styled-components";
import logo from "./assets/images/xl_logo.png";

const XlIcon = () => {
    const ImageWrapper = styled.a`
        width: 50px;
        height: 50px;
    `;

    const ImageStyle = styled.img`
        width: 100%;
    `;

    return (
        <ImageWrapper href="/">
            <ImageStyle src={logo} alt="xiao loong" />
        </ImageWrapper>
    );
};

const Remodel = () => {
    const ImageContainer = styled.div`
        width: 100px;
        margin-bottom: 20px;
    `;

    const PageContainer = styled.div`
        padding: 40px;
        display: flex;
        align-items: center;
        flex-flow: column;
        justify-content: center;
    `;

    const P = styled.p`
        color: white;
        text-align: left;
    `;

    const Message = styled.div`
        max-width: 400px;
        font-size: 16px;
    `;
    return (
        <PageContainer>
            <ImageContainer>
                <XlIcon />
            </ImageContainer>
            <Message>
                <P>Dear West Portal Neighbors, Friends and Customers,</P>
                <P>It is with mixed emotions that I am announcing that Xiao Loong Restaurant is closed effective immediately.</P>
                <P>When I started out my business two decades ago, I never would have guessed that this journey would have far exceeded my expectations. More importantly though, from day one, this neighborhood provided me and my family with the warmest of welcomes where I have met so many wonderful customers (some of who have since become dear friends!) that have been supportive throughout all of these past years.</P>
                <P>I want to extend a heartfelt thank you to all of YOU as well as my staff, for all of the unforgettable experiences and great memories that I will forever cherish.</P>
                <P>I will always be grateful for the opportunity that this West Portal neighborhood and surrounding community has provided to me. You are truly the best!</P>
                <P>Till we meet again - please take care!</P>
                <P>Jeff<br/>
                    Owner, Xiao Loong Restaurant<br/>
                    Email address: <a href="mailto:xiaoloongsfwestportal@gmail.com">xiaoloongsfwestportal@gmail.com</a></P>
            </Message>
        </PageContainer>
    );
}

export default Remodel;